// extracted by mini-css-extract-plugin
export default {"thread":"ThreadBubble_thread__CtwjP","thread__discussion":"ThreadBubble_thread__discussion__kEAAz","thread__title":"ThreadBubble_thread__title__vczmp"};